'use strict';

window.CFC = window.CFC || {};
window.CFC.Faq = (function($) {
  var $faqList;
  var allCategory = 'all';
  
  function init() {
    if (!document.getElementById('faqList')) { return; }
    
    allCategory = getAllCategory();
    
    $faqList = $('#faqList');
    
    $faqList.masonry({
      // options
      itemSelector: '.faq__wrap',
      columnWidth: '.faq--sizer'
    });
    
    window.setTimeout(relayout, 1);
    
    $('.faq, .faq__toggle').on('click', function(e) {
      var $this = $(this);
      var $wrap = $this.closest('.faq__wrap');
      const isOpen = $wrap.is('.faq--open');

      // Clicking anywhere on the faq will open the element, but not close it.
      if ($this.is('.faq') && isOpen) {
        return;
      }
      
      e.stopPropagation();
      $wrap.toggleClass('faq--open');
      $wrap.find('.faq__toggle').attr('aria-expanded', isOpen ? 'false' : 'true');
      $wrap.find('.faq__answer').focus();
      relayout();
    });
    
    initHash();
    $(window).on('hashchange', refresh);
    refresh();
    
    document.addEventListener('DescriptionExpander.expanded', relayout);
    document.addEventListener('DescriptionExpander.collapsed', relayout);
  }

  function getAllCategory() {
    var $categories = $('.faqCategory').filter(function() { this.hasAttribute('data-faq-all'); });
    
    if (!$categories.length) { return 'all'; }
    return $categories.first().attr('href').substring(1);
  }
  
  function currentCategory() {
    var hash = window.location.hash;
    
    if (!hash) { return allCategory; }
    
    var $matchingCategory = $('.faqCategory').filter(function() {
      return $(this).attr('href') === hash;
    });

    if (!$matchingCategory.length || $matchingCategory.first()[0].hasAttribute('data-faq-all')) {
      return allCategory;
    }
    
    return $matchingCategory.first().attr('href').substring(1) ;
  }
  
  function initHash() {
    window.location.hash = currentCategory() || '';
  }
  
  function relayout() {
    $faqList.masonry('layout');
  }
  
  function refresh() {
    var category = currentCategory();
    var $faqs = $faqList.find('.faq__wrap');
    var $shownFaqs = $faqs;

    if (category !== allCategory) {
      $shownFaqs = $faqs.filter(function() {
        return $(this).data('categories').includes(category);
      });
    }
    
    $faqs.hide();
    $shownFaqs.show();
    relayout();
    
    refreshSelectedCategory();
  }
  
  function refreshSelectedCategory() {
    var $categories = $('.faqCategory').removeClass('selected');
    var hashedCat = '#' + currentCategory();
    
    $categories.filter(function() { 
      return hashedCat === $(this).attr('href');
    }).addClass('selected');
  }
  
  $(init);
})(jQuery);